import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const StencilFlap = (props) => {
  const name = 'flap';

  const {
    onChangeParameter,
    parameters,
    tooltip,
    className,
    groupName,
    required,
    label,
    errorMessage,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <RadioDualComponent
      name={name}
      label={label}
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      groupName={groupName}
      required={required}
      labelA="No"
      valueA="0"
      labelB="Yes"
      valueB="1"
      labelClassName="d-block"
      errorMessage={errorMessage} />
  );
};

StencilFlap.defaultProps = {
  tooltip: Spree.helpForParameters.flap,
  label: Spree.translations.parameters.flap,
};

export default StencilFlap;
